import './index.css';

export default {
  name: 'AtreeSelect',
  props: {
    id: { type: String, default: () => (`a-tree-select-${Math.random().toString().substring(2)}`) },
    nodeKey: { type: String, default: () => 'id' },
    nodeName: { type: String, default: () => 'label' },
    defaultProps: { type: Object, default: () => ({ children: 'children', label: 'label' }) },
    value: { type: String | Number, default: () => '' },
    data: { type: Array, default: () => null },
    items: { type: Array, default: () => null },
    config: { type: Array, default: () => null },
    option: { type: Array, default: () => null },
    options: { type: Array, default: () => null },
    locate: { type: Boolean, default: () => false },
    loading: { type: Boolean, default: () => false },
    clickAndClose: { type: Boolean, default: () => true },
    emptyText: { type: String, default: () => '无数据' },
  },
  data() {
    return ({
      list: [],
      content: this.value,
      timeout: null,
      selected: null,
      disabled: true,
    });
  },
  watch: {
    value() {
      this.create();
    },
    data: { deep: true, immediate: true, handler() { this.create() } },
    items: { deep: true, immediate: true, handler() { this.create() } },
    config: { deep: true, immadiate: true, handler() { this.create() } },
    option: { deep: true, immediate: true, handler() { this.create() } },
    options: { deep: true, immediate: true, handler() { this.create() } },
  },
  mounted() {
    this.create();
  },
  destroyed() {
    this.cancel();
  },
  methods: {
    mapper({ ...a }) {
      const label = (a[this.nodeName] || a[this.defaultProps.label]) || (a.label || a.title || a.text || a.name);
      const value = `${a[this.nodeKey] || (a.value || a.code || a.id || a.uid || a.uuid)}`;
      const children = a[this.defaultProps.children] || (a.children || a.child || a.node || a.data || a.list || []);
      return ({ id: value, ...a, label, value, children });
    },
    format(array = []) {
      return array && (array.map(a => {
        const { id = '', label = '', value = '', children = [] } = this.mapper(a);
        return ({ id, ...a, label, value, children: this.format(children) });
      }));
    },
    create() {
      this.disabled = true;
      this.$nextTick(() => {
        this.content = this.value;
        this.$nextTick(() => {
          const option = this.options || this.option || this.config || this.items || this.data || [];
          if (option && option.length > 0) {
            this.list = this.format(option);
            this.$nextTick(() => {
              let value = '';
              const recursion = (array = []) => array && (array.forEach(a => {
                if (a.value == this.content) {
                  value = a.value;
                  this.content = a.label;
                  this.selected = a;
                }
                if (a.children) recursion(a.children);
              }));
              recursion(this.list);
              this.$nextTick(() => {
                value && (this.$refs['tree'] && (this.$refs['tree'].setCheckedKeys([value])));
                this.$nextTick(() => this.disabled = false);
              });
            });
          }
        });
      });
    },
    filter(value = '', { label = '' }) {
      if (!value) return true;
      return label.indexOf(value) != -1;
    },
    search(value = '') {
      this.$refs['tree'] && (this.$refs['tree'].filter(value));
    },
    focus() {
      if (this.$refs['tree']) {
        this.$refs['tree'].filter('');
        this.locate && (this.$nextTick(() => {
          const checked = this.$refs['tree'].$el.querySelector('.is-checked');
          this.$nextTick(() => {
            if (checked) {
              if (this.timeout) {
                clearTimeout(this.timeout);
                this.timeout = null;
              } else {
                this.timeout = setTimeout(() => {
                  checked.scrollIntoView();
                  clearTimeout(this.timeout);
                  this.timeout = null;
                }, 400);
              }
            }
          });
        }));
      }
    },
    clear() {
      this.$emit('clear', this.content);
      this.$nextTick(() => {
        this.$emit('input', undefined);
        this.$nextTick(() => this.$refs['tree'] && (this.$refs['tree'].setCheckedKeys([])));
      });
    },
    click(a) {
      this.$emit('click', a);
    },
    change({ ...a }) {
      this.disabled = true;
      this.$nextTick(() => {
        this.clickAndClose && (this.$refs['select'] && (this.$refs['select'].visible = false));
        this.$nextTick(() => {
          this.selected = this.mapper(a);
          this.$nextTick(() => {
            const { children = null, ...object } = this.selected;
            this.$nextTick(() => {
              const { label = '', value = '' } = object;
              this.$nextTick(() => {
                this.content = label;
                this.$nextTick(() => {
                  this.$emit('input', value);
                  this.$nextTick(() => {
                    this.$emit('change', object);
                    this.$nextTick(() => {
                      this.$refs['tree'] && (this.$refs['tree'].setCheckedKeys([value]));
                      this.$nextTick(() => this.disabled = false);
                    });
                  });
                });
              });
            });
          });
        });
      });
    },
    cancel() {
      this.disabled = true;
      this.$nextTick(() => {
        this.content = '';
        this.$nextTick(() => {
          this.selected = null;
          this.$nextTick(() => {
            clearTimeout(this.timeout);
            this.timeout = null;
            this.$nextTick(() => {
              if (this.$refs['tree']) {
                this.$refs['tree'].filter('');
                this.$nextTick(() => {
                  this.$refs['tree'].setCheckedKeys([]);
                  this.$nextTick(() => this.disabled = false);
                });
              }
            });
          });
        });
      });
    },
  },
  render() {
    const { height = 'auto', maxHeight = '360px', placeholder = '输入关键字进行过滤', props = null, treeProps = null, treeAttrs = null, ...attrs } = this.$attrs;
    return (
      <el-select
        ref="select"
        id={this.id}
        clearable
        filterable
        on-focus={this.focus}
        on-clear={this.clear}
        v-model={this.content}
        disabled={this.disabled}
        placeholder={placeholder}
        filter-method={this.search}
        popper-class="a-tree-select"
        {...{ attrs }}
      >
        {this.list.length > 0 ? (
          <div slot="empty" class="a-tree-select-body" style={{ height, maxHeight: (height != 'auto' ? height : maxHeight) }}>
            <el-tree
              data={this.list}
              ref="tree"
              show-checkbox
              defaultExpandAll
              highlight-current
              check-on-click-node
              check-strictly={true}
              node-key={this.nodeKey}
              props={this.defaultProps}
              on-node-click={this.click}
              expand-on-click-node={false}
              on-current-change={this.change}
              filter-node-method={this.filter}
              default-expanded-keys={[this.value]}
              v-loading={this.loading || this.disabled}
              attrs={treeAttrs || treeProps || props || null}
            />
            {this.$slots.default}
          </div>
        ) : <span slot="empty">{this.emptyText}</span>}
      </el-select>
    );
  },
}